// @flow
import React from 'react';
import ScoreFunction from 'components/homes/ownership/Functions/ScoreFunction';
import ScoreRangeBar from 'components/shared/ScoreRangeBar';
import { OwnerReportScore } from './styles';

type ReportScoreProps = {
  size: 'small' | 'big',
  score: number
};

const ReportScore = ({ size = 'small', score }: ReportScoreProps) => {
  const isTenantApproved = score > 580;
  return (
    <React.Fragment>
      {size === 'small' && (
        <React.Fragment>
          <OwnerReportScore>
            <ScoreFunction
              score={score}
              fontSize={24}
              size={81}
              color={isTenantApproved ? '#48c16a' : '#ff0000'}
            />
            <ScoreRangeBar
              width={180}
              style={{ marginLeft: 8 }}
              failed={!isTenantApproved}
            />
          </OwnerReportScore>
        </React.Fragment>
      )}
      {size === 'big' && (
        <React.Fragment>
          <OwnerReportScore size="big">
            <ScoreFunction
              score={score}
              fontSize={36}
              size={147}
              color={isTenantApproved ? '#48c16a' : '#ff0000'}
            />
            <ScoreRangeBar
              width={325}
              barHeight={12}
              limitsFontSize={20}
              labelsFontSize={14}
              failed={!isTenantApproved}
            />
          </OwnerReportScore>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ReportScore;
